"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
var inertia_react_1 = require("@inertiajs/inertia-react");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var AuthenticationCard_1 = __importDefault(require("@/Jetstream/AuthenticationCard"));
var Button_1 = __importDefault(require("@/Jetstream/Button"));
var Input_1 = __importDefault(require("@/Jetstream/Input"));
var Label_1 = __importDefault(require("@/Jetstream/Label"));
var ValidationErrors_1 = __importDefault(require("@/Jetstream/ValidationErrors"));
function TwoFactorChallenge() {
    var route = (0, useRoute_1.default)();
    var _a = (0, react_1.useState)(false), recovery = _a[0], setRecovery = _a[1];
    var form = (0, inertia_react_1.useForm)({
        code: '',
        recovery_code: '',
    });
    var recoveryCodeRef = (0, react_1.useRef)(null);
    var codeRef = (0, react_1.useRef)(null);
    function toggleRecovery(e) {
        e.preventDefault();
        setRecovery(true);
        setTimeout(function () {
            var _a, _b;
            if (recovery) {
                (_a = recoveryCodeRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                form.setData('code', '');
            }
            else {
                (_b = codeRef.current) === null || _b === void 0 ? void 0 : _b.focus();
                form.setData('recovery_code', '');
            }
        }, 100);
    }
    function onSubmit(e) {
        e.preventDefault();
        form.post(route('two-factor.login'));
    }
    return (react_1.default.createElement(AuthenticationCard_1.default, null,
        react_1.default.createElement(inertia_react_1.Head, { title: "Two-Factor Confirmation" }),
        react_1.default.createElement("div", { className: "mb-4 text-sm text-gray-600" }, recovery
            ? 'Please confirm access to your account by entering one of your emergency recovery codes.'
            : 'Please confirm access to your account by entering the authentication code provided by your authenticator application.'),
        react_1.default.createElement(ValidationErrors_1.default, { className: "mb-4" }),
        react_1.default.createElement("form", { onSubmit: onSubmit },
            recovery ? (react_1.default.createElement("div", null,
                react_1.default.createElement(Label_1.default, { htmlFor: "recovery_code" }, "Recovery Code"),
                react_1.default.createElement(Input_1.default, { id: "recovery_code", type: "text", className: "mt-1 block w-full", value: form.data.recovery_code, onChange: function (e) {
                        return form.setData('recovery_code', e.currentTarget.value);
                    }, ref: recoveryCodeRef, autoComplete: "one-time-code" }))) : (react_1.default.createElement("div", null,
                react_1.default.createElement(Label_1.default, { htmlFor: "code" }, "Code"),
                react_1.default.createElement(Input_1.default, { id: "code", type: "text", inputMode: "numeric", className: "mt-1 block w-full", value: form.data.code, onChange: function (e) { return form.setData('code', e.currentTarget.value); }, autoFocus: true, autoComplete: "one-time-code", ref: codeRef }))),
            react_1.default.createElement("div", { className: "flex items-center justify-end mt-4" },
                react_1.default.createElement("button", { type: "button", className: "text-sm text-gray-600 hover:text-gray-900 underline cursor-pointer", onClick: toggleRecovery }, recovery ? 'Use an authentication code' : 'Use a recovery code'),
                react_1.default.createElement(Button_1.default, { className: (0, classnames_1.default)('ml-4', { 'opacity-25': form.processing }), disabled: form.processing }, "Log in")))));
}
exports.default = TwoFactorChallenge;
